import React, { Component } from "react";
import { createStructuredSelector } from "reselect";
import { selectedOfferSelector, trendingsVisitID } from "../selectors";
import { connect } from "react-redux";
import PaytomorrowContract from "./PaytomorrowContract";
import OkinusContract from "./OkinusContract";
import UownContract from "./UownContract";
import AffContract from "./AffContract";
import AcimaContract from "./AcimaContract";
import SnapContract from "./SnapContract";
import KoalafiContract from "./KoalafiContract";
import OwnleaseContract from "./OwnleaseContract";
import KornerstoneContract from "./KornerstoneContract";
import ProgressiveContract from "./ProgressiveContract";
import { AnalyticAPI } from "api/analytic";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import Flexshopper3Contract from './Flexshopper3Contract';
import Katapult2Contract from './Katapult2Contract';
import ZipContract from './ZipContract';
import Constants from '../../../utils/constants';
import CreditkeyContract from "./CreditkeyContract";

class ContractStep extends Component {
  componentDidMount() {
    const { token, visitID } = this.props;

    AnalyticAPI.send_analytic_event(token, "congrats_screen_viewed", visitID);
  }

  renderPaytomorrowContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <PaytomorrowContract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderKatapult2Contract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <Katapult2Contract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderOkinusContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <OkinusContract selectedOffer={offer || selectedOffer} hidden={hidden} />
    );
  };

  renderUownContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <UownContract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderAffContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <AffContract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderAcimaContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <AcimaContract selectedOffer={offer || selectedOffer} hidden={hidden} />
    );
  };

  renderSnapContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    // The Snap document changes while this step is open (an addendum is signed
    // before the agreement), so the live selected offer wins over the copy
    // stored for multiple iframes.
    const current = offer && selectedOffer && offer.app_id === selectedOffer.app_id ? selectedOffer : offer || selectedOffer;
    return (
      <SnapContract selectedOffer={current} hidden={hidden} />
    );
  };

  renderKoalafiContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <KoalafiContract selectedOffer={offer || selectedOffer} hidden={hidden} />
    );
  };

  renderOwnleaseContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <OwnleaseContract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderFlexshopper3Contract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <Flexshopper3Contract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderKornerstoneContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <KornerstoneContract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderProgressiveContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <ProgressiveContract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderZipContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <ZipContract
        contractUrl={offer?.contractUrl || selectedOffer.contractUrl}
        hidden={hidden}
      />
    );
  };

  renderCreditkeyContract = () => {
    const { selectedOffer, offer, hidden } = this.props;
    return (
      <CreditkeyContract
        agreement={offer?.agreement || selectedOffer.agreement}
        hidden={hidden}
      />
    );
  };

  renderSwitch = (provider, offer = {}) => {
    switch (provider) {
      case "paytomorrow":
        return this.renderPaytomorrowContract();
      case "katapult2":
        return this.renderKatapult2Contract();
      case "flexshopper":
        return this.renderFlexshopper3Contract();
      case "okinus":
        return this.renderOkinusContract();
      case "uown":
        return this.renderUownContract();
      case "aff":
        return this.renderAffContract();
      case "acima":
        return this.renderAcimaContract();
      case "snap":
        return this.renderSnapContract();
      case "koalafi":
        return this.renderKoalafiContract();
      case "ownlease":
        return this.renderOwnleaseContract();
      case "kornerstone":
        return this.renderKornerstoneContract();
      case "progressive":
        return this.renderProgressiveContract();
      case "zip":
        return this.renderZipContract();
      case "creditkey":
        return this.renderCreditkeyContract();
      default:
        return null;
    }
  };

  render() {
    const { selectedOffer, offer } = this.props;
    const activeOffer = offer || selectedOffer;
    return this.renderSwitch(activeOffer.provider, activeOffer);
  }
}

const mapStateToProps = createStructuredSelector({
  selectedOffer: selectedOfferSelector(),
  token: tokenSelector(),
  visitID: trendingsVisitID(),
});

ContractStep = connect(mapStateToProps, null)(ContractStep);

export default ContractStep;
